import { gql } from "@apollo/client";

export const REASIGNAR_PROFESIONAL_RI = gql`
    mutation ReasignarProfesionalRI(
        $input: UpdateMisTareasInput!)
    {
        reasignarProfesionalRI(
            input: $input
        )
    }
`;